<template>
  <div class="body-wrapper">
    <div class="body-content gray">
      <div class="columns">
        <div class="column is-one-quarter">
          <h1 v-if="!user || !user.eventPublished">
            Let's <br />
            get <br />
            started
          </h1>
          <h1 v-if="user && user.eventPublished">
            Your<br />
            Profile
          </h1>
          <div class="box is-hidden-mobile">
            <div class="block">
              <aside class="menu">
                <p class="menu-label">
                  Account Settings
                </p>
                <ul class="menu-list">
                  <li>
                    <a
                      v-bind:class="{ 'is-active': step == 1 }"
                      @click="step = 1"
                      >User Profile</a
                    >
                  </li>
                  <li v-if="user.performingArtist">
                    <a
                      v-bind:class="{ 'is-active': step == 2 }"
                      @click="step = 2"
                      >{{ artistsMenuLabel }}</a
                    >
                  </li>
                  <li v-if="user.venueManager">
                    <a
                      v-bind:class="{ 'is-active': step == 3 }"
                      @click="step = 3"
                      >{{ venuesMenuLabel }}</a
                    >
                  </li>
                  <li v-if="user.festivalManager">
                    <a
                      v-bind:class="{ 'is-active': step == 4 }"
                      @click="step = 4"
                      >{{ festivalsMenuLabel }}</a
                    >
                  </li>
                  <li>
                    <a
                      v-bind:class="{ 'is-active': step == 5 }"
                      @click="step = 5"
                      >Payment Information</a
                    >
                  </li>
                  <li v-if="user.referralCode">
                    <a
                      v-bind:class="{ 'is-active': step == 6 }"
                      @click="step = 6"
                      >Referral Code</a
                    >
                  </li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
        <div class="column" v-show="step == 1">
          <div class="box">
            <p>
              What name should we use to address you when you're logged into
              Gobo? (This can be different from the name people will see on your
              event listings—we'll take care of that later.)
            </p>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">User Name</label>
                  <div class="control">
                    <input
                      class="input is-primary"
                      type="text"
                      placeholder="User Name"
                      v-model="user.name"
                      @change="saveUser"
                    />
                  </div>
                  <p class="help is-danger" v-if="false">
                    Please enter a name.
                  </p>
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label">Roles</label>
              <div class="control">
                <input
                  type="checkbox"
                  id="isPerformingArtist"
                  v-model="user.performingArtist"
                  :class="{
                    'has-background-color': user.performingArtist
                  }"
                  class="is-checkradio is-success"
                  @change="saveUser"
                />
                <label for="isPerformingArtist">
                  Artist/Performer
                </label>
                <input
                  type="checkbox"
                  id="isVenueManager"
                  v-model="user.venueManager"
                  :class="{
                    'has-background-color': user.venueManager
                  }"
                  class="is-checkradio is-success"
                  @change="saveUser"
                />
                <label for="isVenueManager">
                  Venue Manager
                </label>
                <input
                  type="checkbox"
                  id="isFestivalManager"
                  v-model="user.festivalManager"
                  :class="{
                    'has-background-color': user.festivalManager
                  }"
                  class="is-checkradio is-success"
                  @change="saveUser"
                />
                <label for="isFestivalManager">
                  Festival Manager
                </label>
              </div>
            </div>
            <div>
              <button
                style="display: none;"
                class="button is-primary"
                @click="facebook"
              >
                Facebook Me
              </button>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">User Image</label>
                  <div
                    class="imagefield"
                    v-if="!showImagePicker && !showImageLoading"
                  >
                    <img
                      :src="user.avatar"
                      v-if="user.avatar"
                      alt="User Image"
                    />
                    <button class="button" @click="showImagePicker = true">
                      Change Image
                    </button>
                  </div>
                  <UploadImage
                    v-if="showImagePicker"
                    :id="'user-' + user.uid"
                    :outputWidth="460"
                    :outputHeight="460"
                    v-on:imageCropped="saveImage"
                  />
                  <div class="buttons"></div>
                  <div v-if="showImageLoading">
                    <progress
                      class="progress is-primary"
                      :value="percentComplete"
                      max="100"
                      >{{ percentComplete }}</progress
                    >
                    <p>Uploading image...</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column" v-show="step == 2">
          <div class="columns">
            <div class="column">
              <h4>Add artist profile(s) to our database</h4>
            </div>
          </div>
          <div class="box">
            <p v-if="false">
              By creating an artist profile, you will be the owner of that
              profile. That means that you will have access to change
              information in the profile or delete it and create events for it.
              You can also add collaborator, if you’d like, who will have the
              same access.
            </p>
            <p>{{ artistsHeaderLabel }}</p>
            <ActEdit
              v-for="(profile, index) in profiles"
              :key="index"
              :profile="profile"
              :editing="shouldEditArtist || editingArtist == profile.id"
              :menuactive="menuArtist == profile.id"
              v-on:showmenu="activateProfileMenu"
              v-on:profileSet="saveProfile"
              v-on:deleteArtistProfile="deleteArtist"
              v-on:edit="editArtist"
            />
            <div class="buttons">
              <button
                class="button"
                @click="addAct()"
                :disabled="
                  profiles && profiles[0] && !profiles[profiles.length - 1].id
                "
              >
                <span class="icon is-small">
                  <i class="fas fa-plus"></i>
                </span>
                <span>Add Artist</span>
              </button>
            </div>
          </div>
        </div>
        <div class="column" v-show="step == 3">
          <div class="columns">
            <div class="column">
              <h4>Add the venues that you manage.</h4>
            </div>
          </div>
          <div class="box">
            <Venue
              v-for="(profile, index) in venues"
              :key="index"
              :profile="profile"
              :editing="shouldEditVenue || editingVenue == profile.id"
              :editable="true"
              v-on:profileSet="saveVenue"
              v-on:edit="editVenue"
            />
            <div class="buttons">
              <button
                class="button"
                @click="addVenue()"
                :disabled="
                  profiles && profiles[0] && !profiles[profiles.length - 1].id
                "
              >
                <span class="icon is-small">
                  <i class="fas fa-plus"></i>
                </span>
                <span>Add Venue</span>
              </button>
            </div>
          </div>
        </div>
        <div class="column" v-show="step == 4">
          <div class="columns">
            <div class="column">
              <h4>Add the festivals that you manage.</h4>
            </div>
          </div>
          <div class="box">
            <Festival
              v-for="(festival, index) in festivals"
              :key="index"
              :festival="festival"
              :editing="shouldEditFestival || editingFestival == festival.id"
              :editable="true"
              v-on:festivalChanged="saveFestival"
              v-on:edit="editFestival"
            />
            <div class="buttons">
              <button
                class="button"
                @click="addFestival()"
                :disabled="
                  profiles && profiles[0] && !profiles[profiles.length - 1].id
                "
              >
                <span class="icon is-small">
                  <i class="fas fa-plus"></i>
                </span>
                <span>Add Festival</span>
              </button>
            </div>
          </div>
        </div>
        <div class="column" v-show="step == 5">
          <div
            class="box"
            v-if="
              status == 'payment' ||
                status == 'stripeRefresh' ||
                (!status && user.stripeStatus != 'connected')
            "
          >
            <h3><strong>Step 1:</strong></h3>
            <p><strong>Connect a bank account to get paid.</strong></p>
            <br />
            <p>
              In order to send you payments for purchased tickets, we need to
              connect to your bank account. By default, we'll send payments to
              you on a nightly basis (on business days). Gobo collects a flat 5%
              commission that includes credit card processing fees—that's it. No
              other surcharges or transaction costs. If you are only ticketing
              free events, you can skip this step.
            </p>
            <br />
            <p>
              We use Stripe as our digital payment processor. If you have an
              existing Stripe account, we can connect to it. If not, you'll need
              to create one. Click the "Connect" button below to proceed.
            </p>
            <br />
            <a
              v-if="!user.stripeLink"
              @click="createStripeLink"
              class="button is-primary"
              :class="{ 'is-loading': stripelinkStatus }"
              >CONNECT TO STRIPE</a
            >

            <p v-if="stripelinkStatus && stripeProgress < 100">
              Requesting Stripe Link
            </p>
            <p v-if="stripelinkStatus && stripeProgress == 100">
              Stripe Link Created
            </p>
            <progress
              v-if="stripelinkStatus"
              class="progress is-primary"
              :value="stripeProgress"
              max="100"
              >{{ stripeProgress }}%</progress
            >

            <div
              v-if="
                (stripelinkStatus && stripeProgress == 100) || user.stripeLink
              "
            >
              <hr />
              <h3><strong>Step 2:</strong></h3>
              <p>
                We have initiated a connection between Stripe and your Gobo
                profile. Click the button below to finish connecting or creating
                your Stripe account and linking it to Gobo.
              </p>
              <br />
              <a
                v-if="user.stripeLink"
                :href="user.stripeLink.url"
                class="button is-primary"
                >COMPLETE PAYMENT SET UP</a
              >
            </div>
          </div>
          <div class="box" v-if="status && !user.stripeAccount">
            <progress class="progress is-small is-primary" max="100"
              >15%</progress
            >
            <p>Completing Stripe set up...</p>
          </div>
          <div class="box" v-if="user.stripeStatus == 'connected'">
            <p><i class="fas fa-check"></i> Stripe account connected!</p>
          </div>
        </div>
        <div class="column" v-show="step == 6">
          <h4>Referral Link</h4>
          <div class="box">
            <p>
              You can share your referral link with friends to earn credits
              towards your next event. Your referral link is:
            </p>
            <p class="has-text-centered is-size-3">
              https://app.gobo.show/referral/{{ user.referralCode }}
            </p>
            <p class="has-text-centered">Share this code with your friends!</p>
            <p>
              When your friends use your referral code to create an account,
              they will receive a $10 gift card to an independent coffee shop,
              bookstore, or record store (we have a list- they choose), and you
              will receive a $10 gift card as well (same details).
            </p>
            <p>
              By participating in the Gobo Referral Program, you agree to the
              following terms:
            </p>
            <ul class="terms">
              <li>
                Referral codes may only be used for an artist or venue's first
                published event. The codes are not intended for existing Gobo
                users.
              </li>
              <li>
                Referral codes should only be used for personal and
                non-commercial purposes. Codes can be shared on social media and
                with personal connections, but they may not be shared on public
                distribution sites where you are not the primary content owner.
              </li>
              <li>
                Referrals must sign up, create and publish an event, and sell at
                least $50 dollars in tickets to be eligible for the reward. Once
                a referral completes these requirements, each party will receive
                an email with instructions on how to claim their reward.
              </li>
              <li>
                Referrals must be made before the new user signs up, and
                retroactive rewards will not be granted. Any attempt to abuse or
                manipulate the program such as including self-referrals, fake
                events, or fraudulent activity, will result in disqualification
                from the program. Gobo reserves the right to verify eligibility,
                adjust terms, or discontinue the program at any time.
              </li>
            </ul>
          </div>
        </div>
        <div
          class="column is-2 is-1-desktop is-hidden-tablet-only is-hidden-mobile"
        ></div>
      </div>
    </div>
    <div class="box stepbar">
      <div class="columns">
        <div class="column">
          <div class="buttons is-right">
            <button class="button" v-if="step > 1" @click="back()">
              Back
            </button>

            <button
              class="button is-primary"
              v-if="
                step === 1 &&
                  (user.performingArtist ||
                    user.venueManager ||
                    user.festivalManager)
              "
              @click="next()"
            >
              Create Artist/Venue/Festival Profile
            </button>
            <button class="button is-primary" v-if="step === 1" @click="done()">
              Create an event
            </button>

            <button
              class="button is-primary"
              v-if="step > 1 && step !== 5"
              @click="next()"
            >
              Next
            </button>

            <button class="button is-primary" v-if="step === 5" @click="done()">
              Done
            </button>
          </div>
        </div>
        <div
          class="column is-2 is-1-desktop is-hidden-tablet-only is-hidden-mobile"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import UploadImage from "@/components/upload-image";
import ActEdit from "@/components/act-edit";
import Venue from "@/components/venue";
import Festival from "@/components/festival";
import store from "@/store";
import { mapGetters } from "vuex";
import router from "@/router";

export default {
  name: "profile",
  data() {
    return {
      step: 1,
      showImagePicker: true,
      showImageLoading: false,
      percentComplete: 0,
      image: "",
      stripeInProgress: false,
      editingArtist: null,
      menuArtist: null,
      editingVenue: null,
      editingFestival: null,
      creatingStripeAccount: false
    };
  },
  props: ["status"],
  components: { UploadImage, ActEdit, Venue, Festival },
  computed: {
    ...mapGetters({
      user: "user",
      profiles: "getProfiles",
      venues: "venues",
      festivals: "festivals",
      stripelinkStatus: "stripelinkStatus"
    }),
    stripeProgress: function() {
      if (this.stripelinkStatus && this.stripelinkStatus == "submitted")
        return 33;
      if (this.stripelinkStatus && this.stripelinkStatus == "starting")
        return 66;
      if (this.stripelinkStatus && this.stripelinkStatus == "complete")
        return 100;
      return 0;
    },
    artistsMenuLabel: function() {
      return this.profiles && this.profiles.length === 1
        ? "Artist Profile"
        : "My Artists";
    },
    artistsHeaderLabel: function() {
      return this.profiles && this.profiles.length === 1
        ? "Artist Profile"
        : "My Artists";
    },
    venuesMenuLabel: function() {
      return this.venues && this.venues.length === 1
        ? "Venue Profile"
        : "My Venues";
    },
    shouldEditArtist: function() {
      return this.profiles && this.profiles.length === 1;
    },
    shouldEditVenue: function() {
      return this.venues && this.venues.length === 1;
    },
    festivalsMenuLabel: function() {
      return this.festivals && this.festivals.length === 1
        ? "Festival Profile"
        : "My Festivals";
    },
    shouldEditFestival: function() {
      return this.festivals && this.festivals.length === 1;
    }
  },
  created() {
    console.log("Profile created.");
    // FIXED: Uncommented to restore image preview after browser back button
    if (
      this.user &&
      this.user.avatar &&
      this.user.avatar != "/img/icons/icon-profile.svg"
    ) {
      this.showImagePicker = false;
    }

    store.subscribe(mutation => {
      if (mutation.type === "SET_AVATAR") {
        if (this.user.avatar != "/img/icons/icon-profile.svg")
          this.showImagePicker = false;
      }
      if (mutation.type === "SET_USER") {
        if (this.user.avatar != "/img/icons/icon-profile.svg")
          this.showImagePicker = false;
        if (this.status) {
          if (
            this.status == "payment" ||
            this.status == "stripeRefresh" ||
            this.status == "stripeSuccess"
          )
            this.step = 5;
          if (!this.stripeInProgress) {
            this.stripeInProgress = true;
            if (this.status == "stripeSuccess")
              store.dispatch("refreshStripeUrl", "success");
            if (this.status == "stripeRefresh")
              store.dispatch("refreshStripeUrl", "refresh");
          }
        }
      }
    });
  },
  methods: {
    next() {
      if (this.step === 1) {
        this.saveUser();
        // Smart skip based on the roles selected in Step 1
        if (this.user.performingArtist) this.step = 2;
        else if (this.user.venueManager) this.step = 3;
        else if (this.user.festivalManager) this.step = 4;
        else this.step = 5;
      } else if (this.step === 2) {
        if (this.user.venueManager) this.step = 3;
        else if (this.user.festivalManager) this.step = 4;
        else this.step = 5;
      } else if (this.step === 3) {
        if (this.user.festivalManager) this.step = 4;
        else this.step = 5;
      } else if (this.step === 4) {
        this.step = 5;
      } else {
        this.step++;
      }
    },
    back() {
      // Smart skip going backwards
      if (this.step === 5) {
        if (this.user.festivalManager) this.step = 4;
        else if (this.user.venueManager) this.step = 3;
        else if (this.user.performingArtist) this.step = 2;
        else this.step = 1;
      } else if (this.step === 4) {
        if (this.user.venueManager) this.step = 3;
        else if (this.user.performingArtist) this.step = 2;
        else this.step = 1;
      } else if (this.step === 3) {
        if (this.user.performingArtist) this.step = 2;
        else this.step = 1;
      } else {
        this.step--;
      }
    },
    done() {
      router.push("/events/create");
    },
    addAct() {
      store.dispatch("addNewProfile", this.user);
      this.editingArtist = null;
    },
    addVenue() {
      store.dispatch("addNewVenueProfile");
      this.editingVenue = null;
    },
    addFestival() {
      store.dispatch("addNewFestivalProfile");
      this.editingFestival = null;
    },
    saveUser() {
      // FIXED: Removed this.step = 2; to prevent checkboxes from jumping to the next page
      store.dispatch("saveUser", this.user);
    },
    async saveProfile(profile) {
      console.log("saving profile", JSON.stringify(profile));
      if (profile.id) await store.dispatch("savePerformerProfile", profile);
      else {
        var newprof = await store.dispatch("createPerformerProfile", profile);
        this.editingArtist = newprof.id;
        this.$set(this.profiles, newprof.id, newprof);
      }
    },
    async saveVenue(profile) {
      console.log("saving venue", JSON.stringify(profile));
      await store.dispatch("setVenue", profile);
    },
    async saveFestival(festivalId) {
      console.log("saving festivla", JSON.stringify(festivalId));
      this.editingFestival = festivalId;
    },
    editArtist(id) {
      this.menuArtist = null;
      this.editingArtist = id;
    },
    editVenue(id) {
      this.editingVenue = id;
    },
    editFestival(id) {
      this.editingFestival = id;
    },
    deleteArtist(profile) {
      console.log("what the hark");
      this.menuArtist = null;
      var confirm = {
        header:
          "Are you sure you want to delete the artist profile, " +
          profile.name +
          "?",
        message: "",
        cta: "Yes, delete it",
        action: "deleteArtistProfile",
        object: profile
      };
      store.dispatch("showConfirmation", confirm);
    },
    activateProfileMenu(profileid) {
      console.log("Keep showing that menu!");
      this.menuArtist = profileid;
    },
    async saveImage(image) {
      var storageRef = firebase.storage().ref();
      var imagestr = "avatars/" + this.user.uid + ".jpg";
      var imageRef = storageRef.child(imagestr);
      this.showImagePicker = false;
      this.showImageLoading = true;
      var upload = imageRef.put(image);

      upload.on(
        "state_changed",
        upload => {
          var progress = (this.percentComplete =
            (upload.bytesTransferred / upload.totalBytes) * 100);
          console.log("Upload is " + progress + "% done");
        },
        e => {
          console.log("Upload error: ", e);
        },
        () => {
          upload.snapshot.ref.getDownloadURL().then(url => {
            this.image = url;
            console.log("url: ", url);
            store.dispatch("setAvatar", this.image);
            this.showImageLoading = false;
          });
        }
      );
    },
    createStripeLink() {
      store.dispatch("createStripeLink", {
        userId: this.user.uid
      });
    },
    facebook() {
      throw new Error("Bugsnag test.");
    }
  }
};
</script>
<style>
.buttons {
  margin-top: 20px;
}
.terms {
  list-style-type: disc;
  margin-left: 20px;
}
</style>
